<template>
    <div class="pizza-container">
      <canvas ref="pizzaCanvas"></canvas>
    </div>
  </template>
  
  <script>
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels"; 

Chart.register(...registerables, ChartDataLabels);

export default {
  props: {
    numeroDivisoes: {
      type: Number,
      required: true,
      pizzaEmEvidencia: Number
    },
    pizzaEmEvidencia: {
      type: Number,
      default: -1
    },
  },
  data() {
    return {
      pizzaChart: null,
      indexEmEvidencia: -1, // começa sem evidencia
    };
  },
  mounted() {
    this.desenharPizza();
  },
  watch: {
    numeroDivisoes() {
      this.desenharPizza();
    },
    pizzaEmEvidencia(newVal) {
      if (this.pizzaChart) {
        this.pizzaChart.data.datasets[0].offset = this.pizzaChart.data.datasets[0].data.map((_, i) =>
          i === newVal ? 20 : 0
        );
        this.pizzaChart.update();
      }
    }
  },
  methods: {
    desenharPizza() {
      if (this.pizzaChart) {
        this.pizzaChart.destroy();
      }

      const canvas = this.$refs.pizzaCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext("2d");

      if (this.numeroDivisoes === 0) {
        this.pizzaChart = new Chart(ctx, {
          type: "pie",
          data: {
            labels: [""],
            datasets: [{ data: [1], backgroundColor: ["#ccc"], borderWidth: 0 }],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { 
              legend: { display: false },
              tooltip: { enabled: false },
              datalabels: { display: false },
            },
          },
        });
        return;
      }
      const estilos = getComputedStyle(document.documentElement);
      const coresGraficoPizza = [];
      for (let i = 0; i < this.numeroDivisoes; i++) {
        const cor = estilos.getPropertyValue(`--cor-pizza-${i}`).trim();
        coresGraficoPizza.push(cor);
      }
      const cores = coresGraficoPizza;
      const valores = Array(this.numeroDivisoes).fill(1);
      const labels = valores.map(() => `1/${this.numeroDivisoes}`);

      const offsetValor = this.numeroDivisoes === 1 ? 0 : 20;
      // const raio = this.indexEmEvidencia === -1 ? 30 : 100;
      this.pizzaChart = new Chart(ctx, {
        type: "pie",
        data: {
          labels: labels,
          datasets: [{
            data: valores,
            backgroundColor: cores,
            borderWidth: this.numeroDivisoes> 1 ? 2 : 0,
            offset: valores.map((_, i) => i === this.indexEmEvidencia ? offsetValor : 0)
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
            datalabels: this.numeroDivisoes > 0 ? {
              color: "white",
              anchor: 'center',     
              align: 'end',        
              offset: -10,          
              clamp: true,          
              clip: false,
              font: { weight: "bold", size: 12 },
              formatter: (_, context) => labels[context.dataIndex],
            } : { display: false },
          },
          //Atualiza qual pizza está em evidencia e emite um valor para o pai scrollar ate o elemento certo.
          onClick: (event, elements) => {
            if (elements.length > 0) {
              const index = elements[0].index;
              // Emite evento para o pai
              this.$emit('update-pizza', index);
              this.pizzaChart.data.datasets[0].offset = valores.map((_, i) =>
                i === index ? 20 : 0
              );
              this.pizzaChart.update();
            }
          },
          
        },
      });
    },
  },
};
</script>
  
  <style scoped>
  .pizza-container {
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  canvas {
    width: 100%;
    height: 100%;
  }
</style>
  <!-- borderWidth:this.numeroDivisoes>1? 2:0, -->
 